import { render, staticRenderFns } from "./DetailOneAsset_new.vue?vue&type=template&id=2afcef14&scoped=true&"
import script from "./DetailOneAsset_new.vue?vue&type=script&lang=js&"
export * from "./DetailOneAsset_new.vue?vue&type=script&lang=js&"
import style0 from "./DetailOneAsset_new.vue?vue&type=style&index=0&id=2afcef14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afcef14",
  null
  
)

export default component.exports